// ! Esse código todo só é utilizado em um lugar apenas
// ? Existe hoje formas de conversão na classe Coordinate, que já existia antes isoladamente. A diferença desse é que é agrupada.
// TODO Verificar o merge desse arquivo em class Coordinate

export const toDegreesMinutesAndSeconds = (coordinate) => { // converte para graus, minutos e segundos
  let absolute = Math.abs(coordinate);
  let degrees = Math.floor(absolute);
  let minutesNotTruncated = (absolute - degrees) * 60; // minutos
  let minutes = Math.floor(minutesNotTruncated);
  let seconds = Math.floor((minutesNotTruncated - minutes) * 60); // segundos

  return degrees + ' ' + minutes + ' ' + seconds;
};

export const convertDMS = (lat, lng) => { // converte para graus, minutos e segundos
  let latitude = toDegreesMinutesAndSeconds(lat).split(' ');
  latitude = `${latitude[0].padStart(2, '0')}° ${latitude[1].padStart(
    2,
    '0'
  )}' ${latitude[2].padStart(2, '0')}"`; 
  let latitudeCardinal = lat >= 0 ? 'N' : 'S';

  let longitude = toDegreesMinutesAndSeconds(lng).split(' ');
  longitude = `${longitude[0].padStart(2, '0')}° ${longitude[1].padStart(
    2,
    '0'
  )}' ${longitude[2].padStart(2, '0')}"`;
  let longitudeCardinal = lng >= 0 ? 'L' : 'O';

  return {
    lat: latitude + ' ' + latitudeCardinal,
    lng: longitude + ' ' + longitudeCardinal,
  };
};

/**
 * Função para conversão de bytes para KB ou MB
 * < 1000     B
 * > 1000     KB
 * > 500000   MB
 * @param {*} sizeInBytes
 * @returns String com valores convertidos
 */
export const sizeConvert = (sizeInBytes) => { // converte para KB ou MB
  if (sizeInBytes > 1000 && sizeInBytes < 500000) {
    return (sizeInBytes / 1000).toFixed(2) + 'KB';
  } else if (sizeInBytes >= 500000) {
    return (sizeInBytes / 1000000).toFixed(2) + 'MB';
  } else {
    return sizeInBytes.toFixed(2) + 'B';
  }
};
